const spamDomains =
    [
        "mailosaur.net", 
        "mailosur.net",
        "tempmail.com",
        "10minutemail.com",
        "mailinator.com",
        "guerrillamail.com",
        "yopmail.com",
        "getnada.com",
        "dispostable.com",
        "temp-mail.org",
        "temp-mail.io",
        "tempmail.net",
        "tempmailo.com",
        "tempmail.dev",
        "throwawaymail.com",
        "fakeinbox.com",
        "trashmail.com",
        "sharklasers.com",
        "maildrop.cc",
        "moakt.com",
        "mintemail.com",
        "emailondeck.com",
        "burnermail.io",
        "spambox.us",
        "mytemp.email",
        "tempinbox.com",
        "inboxkitten.com",
        "mailnesia.com",
        "anonaddy.com",
        "simplelogin.com"

    ]
export default spamDomains